export const GlobalDebug = (function () { // eslint-disable-line
  const savedConsole = console;
  /**
   * @param {boolean} debugOn
   * @param {boolean} suppressAll
   */
  return function (debugOn, suppressAll) {
    const suppress = suppressAll || false;
    if (debugOn === false) {
      // supress the default console functionality
      console = {}; // eslint-disable-line
      console.log = function () {};
      // supress all type of consoles
      if (suppress) {
        console.info = function () {};
        console.warn = function () {};
        console.error = function () {};
      } else {
        console.info = savedConsole.info;
        console.warn = savedConsole.warn;
        console.error = savedConsole.error;
      }
    } else {
      console = savedConsole; // eslint-disable-line
    }
  };
})();
